import { decimal, integer, maxLength, maxValue, minLength, minValue, required } from 'vuelidate/lib/validators'

import { date } from './customValidators'

const itemModel = {
  no: {
    required,
    maxLength: maxLength(10)
  },
  name: {
    required, maxLength: maxLength(64)
  },
  stage: {
    required,
    integer,
    maxValue: maxValue(2),
    minValue: minValue(0)
  },
  status: {
    required
  },
  description: {
    maxLength: maxLength(256)
  },
  receivedDate: {
    required,
    date
  },
  agreedValueCents: { },
  originalValueCents: { },
  parts: {
    required,
    minLength: minLength(1),
    $each: {
      variationRatio: { decimal }
    }
  }
}

export const variationModel = {
  form: itemModel
}

export const importVariationModel = {
  importedVariations: {
    $each: {
      ...itemModel,
      no: { required, maxLength: maxLength(10) }
    }
  }
}
